import { images } from "../../assets/Images/assetsImages"

const OurTeamSection = () => {
  return (
    <section className="w-full h-[700px] md:h-[800px] 2xl:h-[800px] relative bg-about-team bg-cover border-solid border-2 border-[#41220E]">
        <div className="w-full h-full bg-[#C3D7A4] bg-opacity-50 flex items-start justify-center">
            <div className="w-[70%] lg:w-[55%] xl:w-[50%] h-[90%] bg-[#F5E9D7] rounded-bl-[120px] rounded-br-[120px]">
                <div className="w-full h-full flex flex-col items-center justify-center xs:px-[10px] px-[30px] sm:px-[80px]">
                    <h1 className="font-bold font-playfair text-3xl md:text-4xl mt-10 2xl:mt-0 text-[#41220E]">Our Team</h1>
                    <img src={images.Team} alt="Team" className="xs:w-[80%] w-[70%] sm:w-[60%] xl:w-[50%] xs:h-[30%] h-[50%] sm:h-[40%] rounded-3xl my-[30px] xl:my-[50px]"></img>
                    <p className="font-medium font-montserrat xs:text-[12px] text-[16px] sm:text-[18px] md:text-[20px] xl:text-lg text-[#41220E] text-center mb-20">At Symphony's Artisanal Bakery, we believe that a joyful team creates memorable experiences for our guests. Our dedicated staff is the heart of our bakery, 
                        and we're committed to nurturing their skills and passions. Together, we grow as a family, fostering a positive and supportive work environment where creativity and collaboration thrive.</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default OurTeamSection
